/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedDetailShipping_shipmentQuote$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespShippingReturns_shipmentQuote$ref: FragmentReference;
export type PdpRespShippingReturns_shipmentQuote = {|
  +$fragmentRefs: PdpSharedDetailShipping_shipmentQuote$ref,
  +$refType: PdpRespShippingReturns_shipmentQuote$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_shipmentQuote",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4838708062e93030ab0806d9793b8fff';
module.exports = node;
